import React from 'react';
import { Linkedin, Mail, ArrowUpRight } from 'lucide-react';
import ArtStationIcon from './ui/icons/ArtStationIcon';

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#0a0a0a]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid grid-cols-1 sm:grid-cols-3 gap-6 items-center">
        <div className="font-display font-black text-white text-lg">
          STEPHANOS<span className="text-[#e58a59]">/</span>PAPAS
        </div>
        <div className="text-xs uppercase tracking-[0.25em] text-zinc-500 sm:text-center">
          © {new Date().getFullYear()} · Hamburg · Crafted with intent.
        </div>
        <div className="flex items-center gap-3 sm:justify-end">
          {[
            { Icon: Mail, href: 'mailto:stephanos.papas@outlook.com', id: 'email', external: false },
            { Icon: Linkedin, href: 'https://www.linkedin.com/in/stephanos-papas-780ab7213/', id: 'linkedin', external: true },
            { Icon: ArtStationIcon, href: 'https://stefanosp8.artstation.com', id: 'artstation', external: true },
          ].map(({ Icon, href, id, external }) => (
            <a
              key={id}
              href={href}
              target={external ? '_blank' : undefined}
              rel={external ? 'noreferrer' : undefined}
              className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-zinc-300 hover:text-[#e58a59] hover:border-[#e58a59]/40 transition-colors"
              data-testid={`footer-${id}`}
            >
              <Icon size={14} />
            </a>
          ))}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="ml-2 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-white"
            data-testid="footer-back-to-top"
          >
            Top <ArrowUpRight size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
}
